import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function PageHeader({ eyebrow, title, lead, image, imageAlt }) {
  return (
    <section className="relative overflow-hidden bg-sage/85 pb-16 pt-36 sm:pb-20 sm:pt-44 lg:pb-24 lg:pt-48" data-testid="page-header">
      {image && (
        <>
          <img src={image} alt="" aria-hidden width="620" height="278" loading="eager" fetchPriority="high" className="absolute inset-0 h-full w-full object-cover" />
          <div aria-hidden className="absolute inset-0 bg-gradient-to-r from-sage/95 via-sage/85 to-sage/60" />
        </>
      )}
      <div className="container-shell relative z-10">
        <Reveal>
          <p className="eyebrow">{eyebrow}</p>
          <h1 className="mt-5 max-w-3xl text-balance font-serif text-4xl leading-[1.08] tracking-tight text-olive sm:text-5xl lg:text-6xl">{title}</h1>
        </Reveal>
        {lead && (
          <Reveal delay={0.12}>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-moss sm:text-lg">{lead}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}

export function DetailRow({ title, children, testId }) {
  return (
    <Reveal className="grid gap-3 border-t border-line py-8 md:grid-cols-[220px_1fr]" data-testid={testId}>
      <h3 className="font-serif text-xl text-olive sm:text-2xl">{title}</h3>
      <div className="text-base leading-relaxed text-moss">{children}</div>
    </Reveal>
  );
}

export function LinkArrow({ to, children, testId }) {
  return (
    <Link to={to} data-testid={testId} className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.14em] text-pine transition-colors hover:text-olive">
      {children} <ArrowRight className="h-4 w-4" />
    </Link>
  );
}
